// extracted by mini-css-extract-plugin
export var buttons = "_av-0";
export var buttonsActive = "_av-h";
export var cancelConfirm = "_av-1";
export var closeButton = "_av-2";
export var column = "_av-3";
export var container = "_av-4";
export var detailHeader = "_av-6";
export var detailTitle = "_av-7";
export var detailsContent = "_av-5";
export var header = "_av-8";
export var headerWithClose = "_av-9";
export var icon = "_av-a";
export var infoIcon = "_av-c";
export var informationContainer = "_av-b";
export var sideDrawer = "_av-d";
export var sideDrawerOpen = "_av-e";
export var stickyFooter = "_av-f";
export var typeOption = "_av-g";